import axiosInstance from "auth/FetchInterceptor";
import { TONGHOP_DAT_LICH_API } from "constants/ApiConstant";

const TongHopDatLichService = {};

TongHopDatLichService.search = function (data) {
  return axiosInstance.post(`${TONGHOP_DAT_LICH_API}/search`, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.create = function (data) {
  return axiosInstance.post(TONGHOP_DAT_LICH_API, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.getById = function (id) {
  return axiosInstance.get(`${TONGHOP_DAT_LICH_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.update = function (data) {
  return axiosInstance.put(TONGHOP_DAT_LICH_API, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.delete = function (id) {
  return axiosInstance.delete(`${TONGHOP_DAT_LICH_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.chot = function (id) {
  return axiosInstance.put(`${TONGHOP_DAT_LICH_API}/chot?id=${id}`, null, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.getChiTiet = function (tongHopId) {
  const query = tongHopId ? `?tongHopId=${tongHopId}` : "";
  return axiosInstance.get(`${TONGHOP_DAT_LICH_API}/chi-tiet${query}`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

TongHopDatLichService.updateChiTiet = function (data) {
  return axiosInstance.put(`${TONGHOP_DAT_LICH_API}/chi-tiet`, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

export default TongHopDatLichService;
